// src/components/Terms.js
import React from 'react';
import './Terms.scss';

const Terms = () => {
  return (
    <div className="terms-page">
      <h1>Terms of Service</h1>
      <p>Welcome to OnePimeh Tech. By using our website, you agree to comply with and be bound by the following terms and conditions of use.</p>
      <h2>Use of the Site</h2>
      <p>You agree to use the site only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the site.</p>
      <h2>Intellectual Property</h2>
      <p>All content on this site, including text, graphics, logos, and images, is the property of OnePimeh Tech and is protected by copyright and other intellectual property laws.</p>
      <h2>Limitation of Liability</h2>
      <p>OnePimeh Tech will not be liable for any damages arising from the use of this site.</p>
      <h2>Changes to These Terms</h2>
      <p>We reserve the right to modify these terms at any time. Your continued use of the site after any changes indicates your acceptance of the new terms.</p>
      <h2>Contact Us</h2>
      <p>If you have any questions about these Terms of Service, please contact us at <a href="mailto:terms@onepimeht.tech">terms@onepimeht.tech</a>.</p>
    </div>
  );
};

export default Terms;
